import { useMediaQuery, Grid, colors } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { IconAlternate } from '@/src/components/molecules';
import { DescriptionListIcon } from '@/src/components/organisms';

import SectionDynamic from './SectionDynamic';

const useStyles = makeStyles(() => ({
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
}));

export default function Services(props) {
  const { className, section, services, refElem, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <SectionDynamic type={section} className={classes.sectionNoPaddingTop}>
      <div className={className} ref={refElem} {...rest}>
        <Grid container spacing={isMd ? 4 : 2}>
          {services.map((item, index) => (
            <Grid key={item.title || index.toString()} item xs={12} sm={4} data-aos="fade-up">
              <DescriptionListIcon
                title={item.title}
                subtitle={item.subtitle}
                icon={<IconAlternate fontIconClass={item.icon} size="medium" color={colors.blue} />}
                align="left"
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </SectionDynamic>
  );
}

Services.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  services: PropTypes.array.isRequired,
  refElem: PropTypes.any,
};
